// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom Components
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
// Assets
import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone, MdInfoOutline } from 'react-icons/md';
import { FaEthereum } from 'react-icons/fa';
import Configurator from 'components/navbar/Configurator';
import useRoutes from 'routes';
import { useAuth } from 'contexts/authContext';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { authRepository, User } from 'api/authRepository';
import { jwtDecode } from 'jwt-decode';
export default function HeaderLinks(props: {
  secondary: boolean;
  [x: string]: any;
}) {
  const routes = useRoutes();
  const { secondary, theme, setTheme } = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');
  const { logout, fullName, userId, profilePictureUrl, setProfilePictureUrl } = useAuth();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState<string>('User');
  const handleLogout = () => {
    logout();
    navigate('/auth/sign-in');
  }
  useEffect(() => {
    let active = true;
    const fetchUserProfile = async () => {
      if (!userId) return;

      try {
        const user: User = await authRepository.getUserById(userId);
        const pictureUrl = await authRepository.resolveProfilePicture(user);
        if (!active) {
          if (pictureUrl?.startsWith('blob:')) URL.revokeObjectURL(pictureUrl);
          return;
        }
        setFirstName(user.firstName || 'User');
        setProfilePictureUrl(pictureUrl);
      } catch (error) {
        console.error('Unable to load user profile picture:', error);
      }
    };

    fetchUserProfile();
    return () => {
      active = false;
    };
  }, [userId, setProfilePictureUrl]);
  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="999px"
      boxShadow={shadow}
    >
      <SidebarResponsive routes={routes} />
      <Menu>
        {/* <MenuButton p="0px">

        </MenuButton> */}
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: '30px', md: 'unset' }}
          minW={{ base: 'unset', md: '400px', xl: '450px' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Flex w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notifications
            </Text>
            <Text
              fontSize="sm"
              fontWeight="500"
              color={textColorBrand}
              ms="auto"
              cursor="pointer"
            >
              Mark all read
            </Text>
          </Flex>
          <Flex flexDirection="column">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
              <ItemContent info="Horizon UI Dashboard PRO" />
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
              <ItemContent info="Horizon Design System Free" />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color={textColor}
            name={fullName}
            src={profilePictureUrl || undefined}
            bg="#b8b7c6"
            size="sm"
            w="50px"
            h="50px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
            // color={textColor}
            >
              👋&nbsp; Hey, {firstName || 'User'}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              borderRadius="8px"
              px="14px"
              onClick={() => navigate('/admin/profile-settings')}
            >
              <Text fontSize="sm">Profile Settings</Text>
            </MenuItem>
            <Button
              onClick={handleLogout}
              fontSize="xs"
              variant="no-effects"
              borderRadius="50px"
              px="45px"
              colorScheme='red'
              display={{ sm: 'none', lg: 'flex' }}
            >
              Log Out
            </Button>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
